import { axios } from '@/lib/axios';

export const updateUser = async (id: number, dataToUpdate: any) => {
    const { success, message } = await axios.post(`v1/update-corporation-user/${id}`, dataToUpdate);

    return { success, message };
};
